import React, { useState } from 'react';



const SchedulingAvailability = () => {
  const [weekAvailability, setWeekAvailability] = useState({
    Sunday: [{ start: '18:00', end: '19:00' }],
    Monday: [{ start: '18:00', end: '19:00' }],
    Tuesday: [{ start: '18:00', end: '19:00' }],
    Wednesday: [{ start: '18:00', end: '19:00' }],
    Thursday: [{ start: '18:00', end: '19:00' }],
    Friday: [{ start: '18:00', end: '19:00' }],
    Saturday: [{ start: '18:00', end: '19:00' }],
  });

  const handleAddSlot = (day) => {
    setWeekAvailability({
      ...weekAvailability,
      [day]: [...weekAvailability[day], { start: '', end: '' }],
    });
  };

  const handleChangeSlot = (day, index, field, value) => {
    const updatedSlots = [...weekAvailability[day]];
    updatedSlots[index][field] = value;
    setWeekAvailability({ ...weekAvailability, [day]: updatedSlots });
  };

  const handleDeleteSlot = (day, index) => {
    const updatedSlots = weekAvailability[day].filter((_, i) => i !== index);
    setWeekAvailability({ ...weekAvailability, [day]: updatedSlots });
  };

  return (
    <div className="">

      
      <div style={{ backgroundColor: 'rgba(0,0,0,0.4)', color: 'white', padding: '20px', borderRadius: '8px' }}>
      <h1>Scheduling Availability</h1>
      <p>Specify the client's availability for workouts throughout the week.</p>

      </div>

      <div className="week-calendar">
        {Object.keys(weekAvailability).map((day) => (
          <div key={day} className="day-block">
            <h3>{day}</h3>
            {weekAvailability[day].map((slot, index) => (
              <div key={index} className="availability-slot">
                <span>
                  <p>Slot #{index + 1}</p>
                  <button className="delete-slot" onClick={() => handleDeleteSlot(day, index)}>X</button>
                </span>
                <div className="slot-row">
                  <input
                    type="time"
                    value={slot.start}
                    onChange={(e) => handleChangeSlot(day, index, 'start', e.target.value)}
                  />
                  <input
                    type="time"
                    value={slot.end}
                    onChange={(e) => handleChangeSlot(day, index, 'end', e.target.value)}
                  />
                </div>
              </div>
            ))}
            <button className="add-slot" onClick={() => handleAddSlot(day)}>
              <span className="icon">+</span> Add Slot
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SchedulingAvailability;